import { Navigate } from "react-router-dom";
import Spinner from "../../pages/layout/Spinner";
import { useSelector } from "react-redux";
import {
  getEffectivePermissions,
  getRoleHome,
} from "../../config/pagePermissions";

const PrivateRoute = ({
  component: renderComponent,
  pageKey,
  adminOnly = false,
}) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.loading.loading);
  const permissionState = useSelector((state) => state.permissions);

  if (loading || (localStorage.token && user?.role == null)) {
    return <Spinner />;
  }

  if (!localStorage.token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && Number(user.role) !== 1) {
    return (
      <Navigate
        to={getRoleHome(
          user.role,
          getEffectivePermissions(user, permissionState.roles),
        )}
        replace
      />
    );
  }

  if (pageKey && permissionState.loading) return <Spinner />;

  const userPermissions = getEffectivePermissions(user, permissionState.roles);

  if (pageKey && !userPermissions.includes(pageKey)) {
    return <Navigate to={getRoleHome(user.role, userPermissions)} replace />;
  }

  // `component` is a render callback. Calling it returns the real page element,
  // whose type stays stable when an ancestor re-renders (for example when the
  // sidebar or theme changes). Rendering the callback with <Component /> would
  // treat each newly-created inline callback as a different component type and
  // remount the page, causing its data-loading effects to run again.
  return renderComponent();
};

export default PrivateRoute;
